
const state = {
  id: null,
  brand_id: undefined,
  title: '',
  full_access: false,
  agency_paginated: false,
  debug_mode: false,
  disable_agency_sharing: false,
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'title' },
]

export default state
